import React, { useCallback, useEffect, useMemo, useState } from "react";
import { Box, Chip, Typography } from "@mui/material";
import BoxMedia from "../../items/fragments/BoxMedia.js";
import QuillEditor from "../../lib/quill/QuillEditor.js";
import { loadTwitterScript } from "../../lib/quill/modules/twitter/loadTwitterScript.js";

const MediaArticleComponent = ({ item, match, onTagClick }) => {
    const { title, content, imageUrl, timer, period, creation } = item;
    const [isPortrait, setIsPortrait] = useState(false);

    useEffect(() => {
      if (!imageUrl) return;
  
      const imageObject = new Image();
      imageObject.src = imageUrl;
  
      imageObject.onload = () => {
        setIsPortrait(imageObject.width <= imageObject.height);
      };
    }, [imageUrl]);

    // Ne charge Twitter que si l'article contient réellement un embed.
    const hasTwitterEmbed = useMemo(() => {
      if (typeof content !== 'string') return false;

      return /(?:twitter-tweet|ql-(?:tweet|twitter)|<twitter\b|(?:twitter\.com|x\.com)\/)/i.test(
        content
      );
    }, [content]);

    useEffect(() => {
      if (!hasTwitterEmbed) return;

      loadTwitterScript().catch((reason) => {
        const error =
          reason instanceof Error
            ? reason
            : new Error(`Échec du chargement Twitter : ${String(reason)}`);

        console.error('Erreur de chargement du script Twitter:', error);
      });
    }, [hasTwitterEmbed]);

    const isQuillContent = useMemo(() => {
      if (!content || typeof content !== "string") return false;
      const regex = /^<(?!iframe|blockquote)/; // L'expression régulière vérifie que la chaîne commence par '<' mais pas par 'iframe' ou 'blockquote'
      return regex.test(content);
    }, [content]);

    const renderHTML = useCallback((rawHTML) => {
      const divStyle = {
        fontFamily: 'Source Sans Pro', // Ajoutez votre famille de polices ici
      };
    
      return React.createElement("div", { style: divStyle, dangerouslySetInnerHTML: { __html: rawHTML } });
    }, []);

    return (
      <BoxMedia media={item} match={match} onTagClick={onTagClick}>
        <Typography variant="mediaH2" component="div" sx={{
        whiteSpace: 'normal',
        wordBreak: 'break-word',
        overflowWrap: 'break-word',
      }}>{title}</Typography>

        {/** Si 'content' commence par '<' mais pas par '<iframe' ou '<blockquote' ==> alors c'est du quill content */}
        {
          isQuillContent && content ? 
          <QuillEditor theme="snow"
                content={content}
                readOnly={true}
                modules={{toolbar : null}}
            />
            :
            <>
              {renderHTML(content)}
              {imageUrl && (
                <img
                  src={imageUrl}
                  style={isPortrait ? { maxWidth: '100%', maxHeight: 600 } : { width: '100%' }}
                  alt="article"
                />
              )}
            </>
        }
  
      </BoxMedia>
    );
  };

  // On ne rerender le composant que si le content a changé
const MediaArticle = React.memo(MediaArticleComponent, (prev, next) => {
  return (
    prev.item._id === next.item._id &&
    prev.item.content === next.item.content &&
    prev.item.title === next.item.title &&
    prev.item.imageUrl === next.item.imageUrl &&
    JSON.stringify(prev.item.tags || []) === JSON.stringify(next.item.tags || [])
  );
});

  export default MediaArticle;